<template>
  <a class="the-cta-button">
    <div>
      <slot />
    </div>
  </a>
</template>

<style lang="scss">
a.the-cta-button {
  background-color: transparent;
  border: 2px solid white;
  color: white;
  cursor: pointer;
  display: inline-block;
  margin: auto;
  padding: 1px;
  text-decoration: none;
  div {
    border: 1px solid white;
    font-size: 2rem;
    font-weight: 700;
    padding: 0.75rem 6rem;
    text-align: center;
  }

  &:hover {
    border-color: rgb(150, 150, 150);

    div {
      border-color: rgb(150, 150, 150);
    }
  }
}
</style>
